module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-dialog', {
    attrs: {
      "title": "素材库",
      "append-to-body": _vm.append_body,
      "top": "3%",
      "visible": _vm.libDialogVisible,
      "width": "65%"
    },
    on: {
      "update:visible": function($event) {
        _vm.libDialogVisible = $event
      }
    }
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    attrs: {
      "inline": true
    }
  }, [_c('el-form-item', [_c('el-radio-group', {
    attrs: {
      "size": "small"
    },
    model: {
      value: (_vm.type),
      callback: function($$v) {
        _vm.type = $$v
      },
      expression: "type"
    }
  }, [_c('el-radio-button', {
    attrs: {
      "label": "video"
    }
  }, [_vm._v("视频库")]), _vm._v(" "), _c('el-radio-button', {
    attrs: {
      "label": "image",
      "disabled": ""
    }
  }, [_vm._v("图片库")])], 1)], 1), _vm._v(" "), _c('el-form-item', [_c('el-input', {
    staticStyle: {
      "width": "150px"
    },
    attrs: {
      "size": "small",
      "placeholder": "搜索关键词/ID"
    },
    model: {
      value: (_vm.keyword),
      callback: function($$v) {
        _vm.keyword = $$v
      },
      expression: "keyword"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-select', {
    attrs: {
      "size": "small",
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.advertiser_id),
      callback: function($$v) {
        _vm.advertiser_id = $$v
      },
      expression: "advertiser_id"
    }
  }, _vm._l((_vm.advertiserList), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    }, [_c('span', {
      staticStyle: {
        "float": "left",
        "font-size": "9px"
      }
    }, [_vm._v(_vm._s(item.label))]), _vm._v(" "), _c('span', {
      staticStyle: {
        "float": "right",
        "color": "#8492a6",
        "font-size": "9px"
      }
    }, [_vm._v(_vm._s(item.value))])])
  }), 1)], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "size": "small"
    }
  }, [_c('i', {
    staticClass: "el-icon-search"
  }), _vm._v(" 查询")])], 1)], 1)], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.listLoading),
      expression: "listLoading"
    }],
    staticClass: "card-lists card-lists-vertical material-lib-item"
  }, [_c('el-checkbox-group', {
    staticStyle: {
      "font-size": "14px"
    },
    model: {
      value: (_vm.sels),
      callback: function($$v) {
        _vm.sels = $$v
      },
      expression: "sels"
    }
  }, _vm._l((_vm.list), function(item) {
    return _c('div', {
      staticClass: "card-list video-vertical"
    }, [_c('div', {
      staticClass: "card-list-wrapper"
    }, [_c('div', {
      staticClass: "card"
    }, [_c('div', {
      staticClass: "card-video"
    }, [_c('img', {
      staticClass: "j-ignore",
      attrs: {
        "src": item.poster_url
      },
      on: {
        "click": function($event) {
          return _vm.viewVideo(item)
        }
      }
    }), _vm._v(" "), _c('img', {
      staticClass: "video-play-icon",
      staticStyle: {
        "width": "30px",
        "height": "30px"
      },
      attrs: {
        "src": "//s1.pstatp.com/bytecom/platform_web/static/image/play.svg?f3db861d10cf31d0ff0778b1b4331ba9"
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "card-duration"
    }, [_vm._v(_vm._s(item.duration) + "s")]), _vm._v(" "), _c('div', {
      staticClass: "card-checkbox_hw"
    }, [_c('el-checkbox', {
      attrs: {
        "label": item
      }
    }, [_vm._v(" ")])], 1)]), _vm._v(" "), _c('div', {
      staticClass: "card-desc card-desc-normal"
    }, [_c('p', [_vm._v(_vm._s(item.id))])])])])])
  }), 0)], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "15px",
      "text-align": "center"
    }
  }, [_c('el-pagination', {
    attrs: {
      "background": "",
      "layout": "prev, pager, next",
      "page-size": _vm.pagesize,
      "total": _vm.total
    },
    on: {
      "current-change": _vm.handleCurrentChange
    }
  })], 1)], 1), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('span', {
    staticStyle: {
      "float": "left"
    }
  }, [_vm._v("已选:" + _vm._s(_vm.selsNum) + "/" + _vm._s(_vm.total))]), _vm._v(" "), _c('el-button', {
    on: {
      "click": function($event) {
        _vm.libDialogVisible = false
      }
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.Confirm
    }
  }, [_vm._v("确 认")])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4552a166"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/adv/model/model/lib.vue
// module id = 1098
// module chunks = 36